<template>
    <a-modal
        :visible="visible"
        :title="mode==='create'?'新增用户':`修改【${record?record.name:''}】的信息`"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="member-create" :rules="rules">
            <a-form-model-item label="姓名" prop="name">
                <a-input v-model="form.name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="手机号码" prop="mobile">
                <a-input v-model="form.mobile"></a-input>
            </a-form-model-item>

            <a-form-model-item label="所在部门" prop="group_id">
                <a-select
                    v-model="form.group_id"
                    :getPopupContainer="trigger => trigger.parentNode"
                >
                    <a-select-option
                        v-for="(item,index) in data_group"
                        :key="index"
                        :value="item.id"
                    >{{item.name}}</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="允许访问的部门" extra="不选则只能查看自己录入的数据">
                <a-select
                    mode="multiple"
                    style="width: 100%"
                    v-model="form.groups"
                    :getPopupContainer="trigger => trigger.parentNode"
                >
                    <a-select-option
                        v-for="(item,index) in data_group"
                        :key="index"
                        :value="item.id"
                    >{{item.name}}</a-select-option>
                </a-select>
            </a-form-model-item>

             <a-form-model-item label="客户数量限制" prop="member_limit">
                <a-input v-model="form.member_limit"></a-input>
            </a-form-model-item>


            <a-form-model-item label="角色/权限" prop="role_id">
                <a-select v-model="form.role_id" :getPopupContainer="trigger => trigger.parentNode">
                    <a-select-option
                        v-for="(item,index) in data_role"
                        :key="index"
                        :value="item.id"
                    >{{item.name}}</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="密码（长度6-15位）">
                <a-input v-model="form.password" placeholder="留空则不修改"></a-input>
            </a-form-model-item>

            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
let init_form = {
    name: null,
    mobile: null,
    group_id: null,
    role_id: null,
    password: null,
    remark: null,
    member_limit:null,
    groups: []
};
export default {
    props: {
        visible: {
            default: false
        },
        record: null,
        mode: {
            default: "create"
        }
    },
    data() {
        return {
            submitting: false,
            data_group: [],
            data_role: [],
            rules: {
                name: [
                    {
                        required: true,
                        trigger:['change', 'blur'],
                        message: "请输入姓名"
                    }
                ],
                mobile: [
                    {
                        required: true,
                        trigger:['change', 'blur'],
                        message: "请输入手机号码"
                    }
                ],
                role_id: [
                    {
                        required: true,
                        trigger:['change', 'blur'],
                        message: "请选择角色"
                    }
                ],
                group_id: [
                    {
                        required: true,
                        trigger:['change', 'blur'],
                        message: "请选择部门"
                    }
                ]
            },
            form: null
        };
    },
    created() {
        this.form = JSON.parse(JSON.stringify(init_form));
        this.load_group();
        this.load_role();
    },
    watch: {
        visible(e) {
            if (e && this.record) {
                Object.keys(this.form).map(v => {
                    if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                        if (v === "groups") {
                            this.form["groups"] = this.record[
                                "groups"
                            ].map(v => v.id);
                        } else {
                            this.form[v] = this.record[v];
                        }
                    }
                });
            }
        }
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        on_submit() {
            this.$refs["member-create"].validate(valid => {
                if (valid) {
                    if (this.mode === "create") {
                        return this.on_create();
                    } else {
                        return this.on_edit();
                    }
                } else {
                    this.$message.error("请检查并填写完需要录入的内容");
                    return false;
                }
            });
        },
        on_create() {
            this.submitting = true;
            this.$http
                .post("/auth/user/", this.form)
                .then(res => {
                    if (res.success) {
                        this.cancel();
                        this.$emit("load");
                        this.$message.success(res.message);
                    } else {
                        this.$error({ title: "失败", content: res.message });
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.submitting = false;
                });
        },
        on_edit() {
            this.submitting = true;
            this.$http
                .put("/auth/user/" + this.record.id, this.form)
                .then(res => {
                    if (res.success) {
                        this.$message.success(res.message);
                        this.cancel();
                        this.$emit("load");
                    } else {
                        this.$error({ title: "失败", content: res.message });
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.submitting = false;
                });
        },
        load_group() {
            this.$http
                .get(`/auth/group`)
                .then(res => {
                    if (res.success) {
                        this.data_group = res.data;
                    }
                })
                .catch(() => {})
                .then(() => {});
        },
        load_role() {
            this.$http
                .get(`/auth/role`)
                .then(res => {
                    if (res.success) {
                        this.data_role = res.data;
                    }
                })
                .catch(() => {})
                .then(() => {});
        },
        after_close() {
            this.$refs["member-create"].resetFields();

            this.form = JSON.parse(JSON.stringify(init_form));
        }
    }
};
</script>
